import { combineEpics } from "redux-observable";
import { epicConvertReceivedPackageInfo } from "./epics/epicConvertReceivedPackageInfo";
import { epicSetPurchasePackageInfo } from "./epics/epicSetPurchasePackageInfo";
export var epicPurchasePackages = combineEpics(epicConvertReceivedPackageInfo, epicSetPurchasePackageInfo);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/purchase-packages/epicPurchasePackages.ts
// module id = 1945
// module chunks = 3